import { render, staticRenderFns } from "./huakuai.vue?vue&type=template&id=6a4f34af&scoped=true&"
import script from "./huakuai.vue?vue&type=script&lang=js&"
export * from "./huakuai.vue?vue&type=script&lang=js&"
import style0 from "./huakuai.vue?vue&type=style&index=0&id=6a4f34af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4f34af",
  null
  
)

export default component.exports